import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const MenuSection = ({ translations, menuCategories }) => {
  return (
    <section id="menu" className="py-20 bg-gradient-to-b from-cream-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-brown-900 mb-4">
            {translations.menuTitle}
          </h2>
          <p className="text-xl text-brown-700 mt-4">{translations.menuSubtitle}</p>
          <div className="w-24 h-1 bg-brown-700 mx-auto mt-6"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {menuCategories.map((category) => (
            <Card
              key={category.id}
              className="hover:shadow-xl transition-all duration-300 hover:scale-105 border-2 border-cream-200 bg-white"
            >
              <CardHeader className="text-center">
                <CardTitle className="text-2xl text-brown-900">{category.name}</CardTitle>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuSection;